import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputRadio } from "../../../../HtmlComponents/InputRadio";
import { InputCheckbox } from "../../../../HtmlComponents/InputCheckbox";
import { InputElement } from "../../../../HtmlComponents/InputElement";

const Section9 = () => {
  const {
    activityMedicine, setActivityMedicine,
    paramedical, setParamedical,
    otherActivities, setOtherActivities,
  } = useContext(RegistrationFormContext);

  const otherActiviesArr: string[] = ["Salariée", "No Salariée"]

  return (
    <>
      <div>
        <p className="font-bold text-main">
          {"34) "}exercez-vous une activité une activité medicale autre que la
          medecine de soins:{" "}
        </p>
        <InputCheckbox
          name="Oui"
          id="activityMedicineOui"
          value={activityMedicine}
          setValue={setActivityMedicine}
        />
        {(activityMedicine === true || (typeof activityMedicine === "string" && activityMedicine !== "false")) && (
          <InputElement
            inputClass="md:w-1/2"
            name="Laquelle?"
            value={activityMedicine}
            setValue={setActivityMedicine}
          />
        )}
      </div>
      <div>
        <p className="font-bold text-main">
          {"35) "}envisagez-vous d'exercez une activité professionnelle
          paramedicale:{" "}
        </p>
        <InputCheckbox
          name="Oui"
          id="paramedicalOui"
          value={paramedical}
          setValue={setParamedical}
        />
        {(paramedical === true || (typeof paramedical === "string"  && paramedical !== "false")) && (
          <InputElement
            inputClass="md:w-1/2"
            name="Laquelle?"
            value={paramedical}
            setValue={setParamedical}
          />
        )}
      </div>
      <div>
        <p className="font-bold text-main">
          {"36) "}Aurez-vous une activité autre que medicale ou paramedicale:{" "}
        </p>
        <InputRadio
          checked={otherActivities === "Salariée" && true}
          labelName="Salariée"
          id="Salariée"
          value={"Salariée"}
          setValue={setOtherActivities}
        />
        <InputRadio
          checked={otherActivities === "No Salariée" && true}
          labelName="No Salariée"
          id="No Salariée"
          value={"No Salariée"}
          setValue={setOtherActivities}
        />
        <InputRadio
          checked={otherActivities && !otherActiviesArr.includes(otherActivities) ? true : false}
          labelName="Autre"
          id="otherActivitiesAutre"
          value={"Autre"}
          setValue={setOtherActivities}
        />
        {(otherActivities && !otherActiviesArr.includes(otherActivities)) && (
          <InputElement
            inputClass="md:w-1/2"
            name="Laquelle?"
            value={otherActivities}
            setValue={setOtherActivities}
          />
        )}
      </div>
    </>
  );
};

export default Section9;
